import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: any[][];
}

declare interface Event {
  evento: '';
  id: null;
  row: null;
}

declare var $: any;

@Component({
  selector: 'app-customers-table',
  templateUrl: './customers-table.component.html',
  styleUrls: ['./customers-table.component.css']
})
export class CustomersTableComponent implements OnInit, AfterViewInit {

  @Input() assigned = false;
  @Input() elements: string[][];
  @Input() options: Array<any> = [];
  @Output() newOptions: EventEmitter<any>;
  @Output() out: EventEmitter<Event>;

  public dataTable: DataTable;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
  ) {
    this.newOptions = new EventEmitter;
    this.out = new EventEmitter;
  }

  saveEmit(accion, id, row = null) {
    let send;
    send = {
      evento: accion,
      id: id,
      row: row
    };
    this.out.emit(send);
  }

  ngOnInit() {
    this.dataTable = {
      headerRow: ['ID', 'Rep name', 'Company Name', 'Name', 'Alias', 'Country', 'email', 'Date', 'Average Rating', 'Status', 'Actions' ],
      footerRow: ['ID', 'Rep name', 'Company Name', 'Name', 'Alias', 'Country', 'email', 'Date', 'Average Rating', 'Status', 'Actions' ],
      dataRows: this.elements
    };
  }

  ngAfterViewInit() {
    let visibility = [];
    for (let option of this.options) {
      visibility.push({
        targets: [option.origin],
        visible: option.visibility,
      });
    }

    let positions = [];
    while (positions.length < this.options.length) {
      for (let option of this.options) {
        if (option.position === positions.length) {
          positions.push(option.origin);
          break;
        }
      }
    }

    let table = $("#customerstables").DataTable({
      colReorder:
        positions.length !== 0
          ? {
              order: positions,
            }
          : true,
      columnDefs: visibility,
      dom: "Bflrtip",
      order: [[ 1, 'desc' ]],
      buttons: [
        {
          extend: "excel",
          text: '<i class="fa fa-file-excel-o"></i>',
          titleAttr: "Excel",
          className: "btn btn-sm btn-outline-success",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "pdf",
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: "PDF",
          className: "btn btn-sm btn-outline-danger",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "print",
          text: '<i class="fa fa-print" aria-hidden="true"></i>',
          titleAttr: "print",
          className: "btn btn-sm btn-outline-primary",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "colvis",
          text: '<i class="fa fa-columns" aria-hidden="true"></i>',
          className: "btn btn-sm btn-outline-info",
          titleAttr: "Column visibility",
        },
      ],
      pagingType: "full_numbers",
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"],
      ],
      responsive: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search records",
      },
    });

    table.on('click', '.emitir', (e) => {
      console.log(e);
      console.log("e.currentTarget.id.split => ", e.target.id.split);
      let res = e.currentTarget.id.split("-");
      console.log("res => ", res);
      this.saveEmit(res[0], res[1]);
    });

    table.on( 'column-reorder', function ( e, settings, details ) {

      for (let col of settings.aoColumns) {
        for (let option of this.options) {
          if (option.origin === col._ColReorder_iOrigCol) {
            option.position = col.idx;
            break;
          }
        }
      }
      this.newOptions.emit(this.options);
    }.bind(this) );

    table.on( 'column-visibility.dt', function ( e, settings, column, state ) {

      for (let option of this.options) {
        if (option.position === column) {
          option.visibility = state;
          break;
        }
      }
      this.newOptions.emit(this.options);
    }.bind(this) );
  }

}
